/**
 * @description
 * Иные модели, которые используются в модулях.
 */

import Vue from 'vue'
import type {
  LpuRequestInterface,
  DoctorRequestInterface,
  ServicesRequestInterface,
  DoctorOnlineRequestInterface,
} from 'www/modules/Schedule/models/request'

export const getModuleOptionsInterface = (): {
  useLogger: boolean
  pageType: string | null
  doctorPageType: string | null
  dataItem: string
  dataStorage: string
  selectorContainersSlots: string | null
  selectorContainerObserver: string | null
} => ({ // базовые опции настройки модуля 'Schedule'
  useLogger: false, // использовать логирование причины ошибки во время валидации
  pageType: null, // одно из полей 'PAGE_TYPE_DATA'. Не используется для настройки модуля. Определяется внутри класса перед вызовом функции 'super' в 'constructor'
  doctorPageType: null, // используется для класса 'DoctorCardEmitter', задает используемое пространство имен
  dataItem: 'data-schedule-item', // data атрибут на странице(1 и более на странице), который хранит в себе данные для модуля 'Schedule'
  dataStorage: 'data-schedule-storage', // data атрибут на странице(только 1), который хранит в себе общие данные для модуля 'Schedule'
  selectorContainersSlots: null, // селектор контейнера, в котором необходимо отрендерить календарь
  selectorContainerObserver: null, // селектор контейнера, который впоследствии будет мутировать, тем самым триггерить модуль отрисовывать календари
})

export type ScheduleRequest =
  | LpuRequestInterface
  | DoctorRequestInterface
  | ServicesRequestInterface
  | DoctorOnlineRequestInterface

export type ScheduleRenderProps = {
  days: string[]
  slots: Record<string, { time: string; free: boolean; duration: number }[]>
  lpuId: number | null
  initDay: string | undefined
  dataItem: string
  lpuWorkingText: string
  doctorsLpuHref: string | null
  appointmentType: string
  data: Record<string, unknown>
  options: Record<string, unknown>
  useRedirect: boolean
  isAppointmentDoctor: boolean
  doctorSpec: unknown
  lpuPhone: string
  serviceIsExpress?: boolean | null
  [key: string]: unknown
}

export const getModuleDataInterface = (): {
  items: Map<HTMLElement, unknown>
  storage: Record<string, unknown>
  instances: Map<HTMLElement, InstanceType<typeof Vue>>
  request: ScheduleRequest
  render: Map<HTMLElement, ScheduleRenderProps>
} => ({ // данные, которые содержит в себе модуль 'ScheduleData'
  items: new Map(), // данные, собранные со страницы из атрибута 'data-schedule-item'
  storage: {}, // данные, собранные со страницы из атрибута 'data-schedule-storage'
  instances: new Map(), // данные для хранения связки узел => компонент, который был отрисован
  request: {} as ScheduleRequest, // данные, которые будут отправляться за получением расписания
  render: new Map(), // данные, которые будут использованы для рендера компонентов
})
